(function (napco, $) {
	napco.usMapsTrigger = function () {
		var $container = $('[data-trigger-map]');
		if (!$container.length) {
			return;
		}
		$container.usmap({
			'stateStyles': {
				fill : '#cf142b'
			},
			'labelBackingStyles': {
				fill : '#cf142b'
			},
			'labelTextStyles': {
				fill : '#fff'
			},
			click: function(event, data) {
				const el = $(".state-"+data.name);


				$(".modal-contact-name").text(el.data('name')?el.data('name'):'');
				$(".modal-contact-title").text(el.data('title')?el.data('title'):'');
				$(".modal-contact-phone").text(el.data('cell')?`Cell: ${el.data('cell')}`:'');
				$(".modal-contact-email").html(el.data('contact')?`E-mail: <a href="mailto:${el.data('contact')}">${el.data('contact')}</a>`:'');

				$('#mapModal').modal('show');
			}
		});

		$(".modal-btn").on('click', function(event, data){
			const el = $(this);

			$(".modal-contact-name").text(el.data('name')?el.data('name'):'');
			$(".modal-contact-title").text(el.data('title')?el.data('title'):'');
			$(".modal-contact-phone").html(el.data('cell')?el.data('cell'):'');
			$(".modal-contact-email").text(el.data('contact')?el.data('contact'):'');

			$('#mapModal').modal('show');
		});
	};
}(window.napco = window.napco || {}, jQuery));
